import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Car } from "lucide-react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

export function VehicleStatusDonut() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  const go = (name) => navigate(`/vehicles?status=${name.toLowerCase()}`);
  useEffect(() => {
    api.get("/dashboard/vehicle-status").then((r) => setD(r.data)).catch(() => {});
  }, []);
  if (!d) return null;
  const data = [
    { name: "Aman", value: d.aman, color: "#10b981" },
    { name: "Segera", value: d.segera, color: "#f59e0b" },
    { name: "Terlambat", value: d.terlambat, color: "#ef4444" },
  ];
  const pct = (v) => (d.total ? Math.round((v / d.total) * 100) : 0);
  return (
    <Card className="p-4" data-testid="vehicle-status-donut">
      <div className="flex items-center gap-2 mb-1">
        <Car className="h-4 w-4 text-brand" />
        <h3 className="font-semibold" style={{ fontFamily: "Outfit" }}>Status Kendaraan</h3>
      </div>
      <p className="text-xs text-muted-foreground mb-2">Total {d.total} kendaraan</p>
      <div className="flex items-center gap-4">
        <div className="relative h-32 w-32 shrink-0">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={data} dataKey="value" innerRadius={44} outerRadius={62} paddingAngle={2} stroke="none" onClick={(e) => go(e.name)} className="cursor-pointer">
                {data.map((e, i) => <Cell key={i} fill={e.color} className="cursor-pointer outline-none hover:opacity-80" data-testid={`donut-segment-${e.name.toLowerCase()}`} />)}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
            <span className="text-xl font-bold" data-testid="donut-total">{d.total}</span>
            <span className="text-[10px] text-muted-foreground">Total</span>
          </div>
        </div>
        <div className="space-y-2 text-sm flex-1">
          {data.map((e) => (
            <button key={e.name} onClick={() => go(e.name)} className="w-full flex items-center gap-2 text-left rounded px-1 -mx-1 hover:bg-secondary" data-testid={`donut-${e.name.toLowerCase()}`}>
              <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ background: e.color }} />
              <span className="flex-1">{e.name}</span>
              <span className="font-semibold">{e.value}</span>
              <span className="text-xs text-muted-foreground">({pct(e.value)}%)</span>
            </button>
          ))}
        </div>
      </div>
    </Card>
  );
}
